const POIInfoTemplate = (params) => {
    let content = `<div class="location-content">`;
    if (params.photoSrc) {
        content += `<div>
                   <img src="${params.photoSrc}" class="location-image">
                </div>`;
    }
    content += `<div class="marker-text-content">
                    <div class="poi-name">
                        ${params.name}
                    </div>
                    <div class="location-description">
                        ${params.formattedAddress}</div>
                </div>
            </div>`;
    return content;
};

export {POIInfoTemplate};
